/**
 * Extracted from sections/ns-text-with-icons.liquid (inline <script> at line 217).
 * Config bridge: window.__nsTextWithIconsSections, keyed by section id — the inline block
 * only needed Liquid for the section id, so the id is now handed over as
 * data and the logic runs from a cacheable, deferred asset instead of
 * being parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances still each initialise.
 */

(function () {
  var cfg = window.__nsTextWithIconsSections = window.__nsTextWithIconsSections || {};
  function boot(sectionId, settings) {
    function textWithIcons () {
      let section = document.querySelector(`#shopify-section-${sectionId}`)

      let breakpoint = window.matchMedia('(min-width:700px)');
      let contentContainerEl = section.querySelector('.ns-text-with-icons')
      let swiperWrapperEl = section.querySelector('[data-swiper-wrapper]')
      let swiperEl = section.querySelector('[data-swiper-container]')
      let swiperPaginationEl = section.querySelector('.swiper-pagination')
      let {
        layoutMobile,
        layoutDesktop,
        itemsPerRowDesktop,
        itemsPerRowMobile,
      } = contentContainerEl.dataset

      let bundlesIntroSwiper
      function initializeSwiper () {
        if (bundlesIntroSwiper) return;
        bundlesIntroSwiper = new Swiper(swiperEl , {
          slidesPerView: itemsPerRowMobile,
          spaceBetween: 10,

          speed: 600,

          breakpoints: {
            320: {
              slidesPerView: itemsPerRowMobile,
              spaceBetween: 32
            },
            480: {
              slidesPerView: itemsPerRowMobile,
              spaceBetween: 32
            },
            640: {
              slidesPerView: itemsPerRowMobile,
              spaceBetween: 32
            },
            800: {
              slidesPerView: 2,
              spaceBetween: 32
            },
            1024: {
              slidesPerView: itemsPerRowDesktop,
              spaceBetween: 32
            }
          },

          autoHeight: true,

          navigation: {
            nextEl: section.querySelector('.text-with-icon__swiper-button-next'),
            prevEl: section.querySelector('.text-with-icon__swiper-button-prev'),
          },

          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true
          },

          on: {
            init: function () {
              // this.updateAutoHeight();
              // setTimeout(() => {
              //   this.updateAutoHeight();
              // }, 2000);
              this.pagination.render();
              this.pagination.init();
              this.pagination.update();
            },

          }

        })
      }


      function destroySwiper() {
          if (typeof bundlesIntroSwiper !== 'undefined') {
              bundlesIntroSwiper.destroy(true, true)
          }
      }
      function breakpointChecker(breakpoint) {
          if (breakpoint.matches === true) {
            if (layoutDesktop == 'slider') {
              swiperWrapperEl.style.display = 'flex'
              swiperWrapperEl.classList.add('swiper-wrapper')
              swiperPaginationEl.style.display = 'block'
              initializeSwiper()
              return
            } else {
              swiperWrapperEl.style.display = 'flex'
              swiperWrapperEl.classList.remove('swiper-wrapper')
              swiperWrapperEl.classList.add('custom-grid-container')
              swiperPaginationEl.style.display = 'none'
              destroySwiper();
              return
            }
          } else if (breakpoint.matches === false) {
            if (layoutMobile == 'slider') {
              swiperWrapperEl.style.display = 'flex'
              swiperWrapperEl.classList.add('swiper-wrapper')
              swiperPaginationEl.style.display = 'block'
              initializeSwiper()
              return
            } else {
              swiperWrapperEl.style.display = 'grid'
              swiperWrapperEl.classList.remove('swiper-wrapper')
              swiperPaginationEl.style.display = 'none'
              destroySwiper();
              return
            }
          }
      };


      breakpointChecker(breakpoint);
      breakpoint.addEventListener("change", () => {
          breakpointChecker(breakpoint)
      })

    }


    nsSwiperReady(textWithIcons)

    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", () => {
        nsSwiperReady(textWithIcons)
      });
    }
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
